import React from 'react'
import { fileSystemUrl } from '../../../constants/Connections'
import { useTranslation } from 'react-i18next'

function TemplateSection() {
    const { t } = useTranslation()
    return (
        <div className="bg-[#FDDF6D66] border border-highlightColor rounded-[24px] p-5 mb-6">
            <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                    <div className="flex items-center justify-center w-[40px] h-[40px] border-deepPurple border rounded-full">
                        <svg className="w-5 h-5 text-deepPurple" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                            />
                        </svg>
                    </div>
                    <div>
                        <h4 className="text-[16px] leading-5 font-bold text-darkPurple mb-1">{t('Need a template?')}</h4>
                        <p className="text-[14px] text-deepPurple font-medium">{t('Download the Excel template to get started with the correct format')}</p>
                    </div>
                </div>
                <a
                    className="inline-flex items-center px-4 h-[40px] bg-highlightColor rounded-full text-deepPurple font-semibold text-[14px] transition-all duration-300 shadow-sm hover:shadow-md"
                    href={`${fileSystemUrl}/public/User_Data_Upload_Template.xlsx`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {t('Download Template')}
                    <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        />
                    </svg>
                </a>
            </div>
        </div>
    )
}

export default TemplateSection
